import { getSpacing } from "@faire/web/slate/spacing";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";
export var ShowMoreCta = function ShowMoreCta(_ref) {
  var visibleWhen = _ref.visibleWhen,
    onClick = _ref.onClick;
  if (!visibleWhen) {
    return null;
  }
  return /*#__PURE__*/React.createElement(InlineCta, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "9YZ8ki",
    defaultMessage: [{
      "type": 0,
      "value": "Meer tonen"
    }]
  }));
};
var InlineCta = styled.span.withConfig({
  displayName: "ShowMoreCta__InlineCta"
})(["text-decoration:underline;cursor:pointer;margin-left:", ";"], getSpacing("1x"));